import { connect } from 'react-redux'
import AssistanceList from '../../components/global-settings/AssistanceList'
import { IStoreState } from '../../types/index'
import { getAssistances, getAssistanceCategories } from 'src/state/actions/assistance'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    assistances: state.assistances.items,
    categories: state.assistanceCategories.items
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    getAssistances: () => {
      dispatch(getAssistances())
    },
    getAssistanceCategories: () => {
      dispatch(getAssistanceCategories())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssistanceList)



// WEBPACK FOOTER //
// ./src/containers/global-settings/AssistanceList.ts